module.exports = __webpack_public_path__ + "static/media/save-contract-hubita-renewal.9dd90ceb.gif";